import type { BootstrapData, RegionProgress } from '../types';

export const completedRegion = (progress: RegionProgress | undefined): boolean => progress?.status === 'visited' || progress?.status === 'revisit';

export const calculateStats = (data: BootstrapData) => {
  const completed = data.regionProgress.filter((progress) => completedRegion(progress)).length;
  const checkedPlaces = data.placeProgress.filter((progress) => progress.isChecked).length;
  const ratings = [
    ...data.regionProgress.map((progress) => progress.rating),
    ...data.placeProgress.map((progress) => progress.rating),
  ].filter((rating): rating is number => rating !== null);
  const visitedDates = [
    ...data.regionProgress.map((progress) => progress.lastVisitedOn),
    ...data.placeProgress.map((progress) => progress.visitedOn),
  ].filter((date): date is string => Boolean(date));
  const seasons = { 봄: 0, 여름: 0, 가을: 0, 겨울: 0 };
  for (const date of visitedDates) {
    const month = Number(date.slice(5, 7));
    if ([3, 4, 5].includes(month)) seasons.봄 += 1;
    else if ([6, 7, 8].includes(month)) seasons.여름 += 1;
    else if ([9, 10, 11].includes(month)) seasons.가을 += 1;
    else seasons.겨울 += 1;
  }
  const percentage = data.regions.length ? Math.round((completed / data.regions.length) * 100) : 0;
  const level = percentage === 100 ? '대한민국 정복자' : percentage >= 75 ? '국내여행 고수' : percentage >= 50 ? '전국 탐험가' : percentage >= 25 ? '여행 수집가' : '설레는 입문자';
  return {
    completed,
    percentage,
    checkedPlaces,
    averageRating: ratings.length ? ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length : 0,
    wishlist: data.regionProgress.filter((progress) => progress.status === 'wishlist').length,
    planned: data.regionProgress.filter((progress) => progress.status === 'planned').length,
    revisit: data.regionProgress.filter((progress) => progress.status === 'revisit').length,
    nextCandidates: data.regionProgress.filter((progress) => progress.isNextCandidate).length,
    planCount: data.plans.length,
    seasons,
    level,
  };
};
